import { getShowScoringDate, getFactionMemberRoleAtDate } from './factionLineupScoring';
import {
  applyFactionMemberRoleToPoints,
  hasFactionScoringStarted,
  shouldBlockFactionScoringForMissingLineup,
} from './factionScoring';
import { getFactionWrestlerIds } from './factionWrestlers';

export const createInitialGmMatchWeeklyScores = (match) =>
  (match?.participants || []).reduce((acc, participant) => {
    acc[participant.factionId] = 0;
    return acc;
  }, {});

export const buildGmMatchWrestlerToFactionMap = (match, factionsById = {}) => {
  const wrestlerToFactionId = {};

  (match?.participants || []).forEach((participant) => {
    const faction = factionsById[participant.factionId];
    const wrestlerIds = getFactionWrestlerIds(faction);

    wrestlerIds.forEach((wrestlerId) => {
      wrestlerToFactionId[wrestlerId] = participant.factionId;
    });
  });

  return wrestlerToFactionId;
};

export const getGmMatchParticipationScore = ({
  faction,
  roster = null,
  participation,
  showDate,
}) => {
  if (!faction || !participation?.wrestlerId) return 0;
  if (!hasFactionScoringStarted(faction, showDate, roster)) return 0;
  if (shouldBlockFactionScoringForMissingLineup({ faction, roster, referenceDate: showDate })) {
    return 0;
  }

  const roleAtShow = getFactionMemberRoleAtDate(
    faction,
    participation.wrestlerId,
    showDate
  );

  return applyFactionMemberRoleToPoints(participation.totalPoints || 0, roleAtShow);
};

export const calculateGmMatchWeeklyScores = ({
  match,
  factionsById = {},
  rostersByFactionId = {},
  showEntries = [],
}) => {
  const scoresMap = createInitialGmMatchWeeklyScores(match);
  const wrestlerToFactionId = buildGmMatchWrestlerToFactionMap(match, factionsById);

  showEntries.forEach((entry) => {
    const show = entry?.show || entry || {};
    const showDate = getShowScoringDate(show);
    const participations = Array.isArray(entry?.participations)
      ? entry.participations
      : [];

    participations.forEach((participation) => {
      const factionId = wrestlerToFactionId[participation.wrestlerId];
      if (!factionId) return;

      const faction = factionsById[factionId];
      const roster = rostersByFactionId[factionId] || null;
      const scoredPoints = getGmMatchParticipationScore({
        faction,
        roster,
        participation,
        showDate,
      });

      scoresMap[factionId] = (scoresMap[factionId] || 0) + scoredPoints;
    });
  });

  return scoresMap;
};
